export default "__VITE_ASSET__72663dff__"